

exports.__esModule = true;
exports.$xoCardIssueDateDirective = undefined;

var _squid = require('squid');

require('xo-ui-components/src/tooltip/directive');

require('xo-ui-components/src/error-tooltip/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardIssueDateDirective = exports.$xoCardIssueDateDirective = _squid.$Component.extend('$xoCardIssueDateDirective', {
    tag: 'xo-card-issue-date',
    template: _template2['default'],

    props: {
        issueMonth: {
            type: 'var',
            required: true
        },
        issueYear: {
            type: 'var',
            required: true
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.dateFormat = (0, _squid.$feature)('ccIssueDateDateFormat', 'MMYY', _squid.$locale.country);

            if (this.dateFormat === 'MMYY') {
                this.maxlength = 5;
                this.mask = '99/99';
            } else if (this.dateFormat === 'MMYYYY') {
                this.maxlength = 7;
                this.mask = '99/9999';
            }

            this.formatIssueDate = function (event) {
                var key = event.keyCode || event.charCode;
                var $el = $(event.target);
                var val = $el.val().replace(/[^0-9\/]/gi, '');
                var strokes = val.length;

                // Ignore delete keys
                if (key === 8 || key === 46) {
                    return;
                }

                // after two characters add a slash char
                if (strokes === 2) {
                    val += '/';
                }

                _this.issueDate = val;
                $el.mask(_this.mask);
            };

            var currentYear = new Date().getFullYear();
            var validMonths = _squid.$util.map(_squid.$util.range(1, 13), function (num) {
                return ('0' + num).substr(-2);
            });
            var validYears = _squid.$util.map(_squid.$util.range(currentYear - 10, currentYear + 1), function (y) {
                return y.toString();
            });

            this.validate = function (issueDate) {
                if (!issueDate) {
                    return;
                }

                var month = void 0,
                    year = void 0,
                    unformatted = void 0;
                var isValid = false;

                unformatted = issueDate.replace(/[^0-9]/gi, '');
                if (unformatted.length > 3) {
                    month = unformatted.substring(0, 2);
                    if (_this.dateFormat === 'MMYY') {
                        year = currentYear.toString().substring(0, 2) + unformatted.substring(2, 4);
                    } else if (_this.dateFormat === 'MMYYYY') {
                        year = unformatted.substring(2, 6);
                    }

                    isValid = validMonths.indexOf(month) > -1 && validYears.indexOf(year) > -1;

                    if (isValid) {
                        var date = new Date(year, parseInt(month, 10) - 1);
                        var today = new Date();
                        isValid = date < today;
                    }
                }

                _this.issueYear = year;
                _this.issueMonth = month;

                return isValid;
            };
        }
    }
});

angular.value("$xoCardIssueDateDirective", $xoCardIssueDateDirective);
_squid.$Component;

_squid.$locale;

_squid.$feature;

_squid.$util;


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/add-card/cardIssueDate/directive.js
// module id = ./components/xo-wallet-components/src/add-card/cardIssueDate/directive.js
// module chunks = 1